<ng-container *transloco="let t">
  <app-grid-page [title]="'User Management'">
      <app-grid
        [columns]="columns"
        [data]="users()"
        [rowId]="userId"
        [loading]="isLoading()"
        [page]="page()"
        [pageSize]="size()"
        [totalElements]="totalElements()"
        [totalPages]="totalPages()"
        [sort]="sort()"
        [searchable]="true"
        [selectable]="true"
        [exportable]="true"
        [detailEnabled]="true"
        [(selectedIds)]="selectedIds"
        [primaryAction]="{ label: 'Create user', icon: 'icon-content-add24px' }"
        [rowActions]="[
          { id: 'view', label: 'View', icon: 'icon-visibility-on', placement: 'inline' }
        ]"
        (sortChange)="onSortChange($event)"
        (pageChange)="onPageChange($event)"
        (pageSizeChange)="onPageSizeChange($event)"
        (rowClick)="onRowClick($event)"
        (rowActionClick)="onRowClick($event.row)"
        (primaryActionClick)="openCreateUserDialog()"
      >
        <!-- Angular erases the grid's generic in this host template, so `row`
             arrives as `unknown`; `asUser` locks it back to User for the body. -->
        <ng-template gridCell="roles" let-row>
          @let cellUser = asUser(row);
          <app-label-badge>{{ cellUser.realmRoles.length ? cellUser.realmRoles[0] : t('navbar.defaultRole') }}</app-label-badge>
        </ng-template>

        <ng-template gridDetail let-row>
          @let user = asUser(row);
          <div class="mb-4 h-40 w-full rounded-card bg-sunken"></div>
          <div class="font-display text-xl font-bold text-ink-1">
            {{ user.firstName }} {{ user.lastName }}
          </div>
          <div class="mb-4 text-sm text-ink-3">{{ user.email }}</div>
          <div class="border-t border-hairline">
            <div class="flex items-center justify-between border-b border-hairline py-3">
              <span class="text-[13px] text-ink-3">Email</span>
              <span class="text-[13px] font-semibold text-ink-1">{{ user.email }}</span>
            </div>
            <div class="flex items-center justify-between border-b border-hairline py-3">
              <span class="text-[13px] text-ink-3">Roles</span>
              <span class="text-[13px] font-semibold text-ink-1">{{
                user.realmRoles.join(', ') || t('common.na')
              }}</span>
            </div>
          </div>
        </ng-template>
      </app-grid>
  </app-grid-page>

  @if (isUserDialogOpen()) {
    <app-create-user-dialog
      [organizations]="organizations()"
      [mode]="dialogMode()"
      [user]="currentUser()"
      [selectedTenantIds]="selectedTenantIds()"
      (close)="closeUserDialog()"
      (save)="handleUserSave($event)"
    ></app-create-user-dialog>
  }
</ng-container>
